import React, { PureComponent } from 'react';
import styled from 'styled-components';

import LOGO from 'core/assets/images/mcrcsm_logo.png';

class Logo extends PureComponent {
  render() {
    return (
      <Image src={LOGO} />
    );
  }
}

export default Logo;

const Image = styled.div`
  margin: 20px auto;
  width: 166px;
  height: 93px;
  background-image: url(${LOGO});
  background-size: cover;
`;
